import { render, staticRenderFns } from "./editShiftTypeMapping.vue?vue&type=template&id=b8c3a7fa&"
import script from "./editShiftTypeMapping.vue?vue&type=script&lang=js&"
export * from "./editShiftTypeMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCol,VForm})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8c3a7fa')) {
      api.createRecord('b8c3a7fa', component.options)
    } else {
      api.reload('b8c3a7fa', component.options)
    }
    module.hot.accept("./editShiftTypeMapping.vue?vue&type=template&id=b8c3a7fa&", function () {
      api.rerender('b8c3a7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Shift/ShiftTypeMapping/components/editShiftTypeMapping.vue"
export default component.exports